<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <h1>Роли</h1>


      <v-tabs v-model="tab">
        <v-tab>Роли</v-tab>
        <v-tab>Пользователи</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>

      <v-row align="center">
        <v-col class="text-right" >
          <v-dialog v-model="dialog" max-width="445">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                      v-bind="attrs"
                      v-on="on"
                      @click="clearRole();"
              >
                Создать роль
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ role.id ? 'Редактировать роль' : 'Создать роль'}}</span>
              </v-card-title>
              <v-card-text>
                <v-form ref="tabForm" v-model="valid">
                  <v-text-field
                      label="Название"
                      outlined
                      v-model="role.name"
                      :rules="[rules.required]"
                      required>
                  </v-text-field>
                  <v-text-field
                      label="Слаг (системный)"
                      outlined
                      :readonly="!role.editable"
                      v-model="role.slug"
                      :rules="[rules.required]"
                      required>
                  </v-text-field>
                  <div>
                    <h3>Access</h3>
                    <div class="row">
                      <div class="col-6">
                        Name
                      </div>
                      <div class="col-3">Чтение</div>
                      <div class="col-3">Запись</div>
                    </div>
                    <div class="row" v-for="slug of accessList">

                      <div class="col-6">{{slug}}</div>

                      <div class="col-3">
                      <v-checkbox :readonly="!role.editable" :input-value="role.access && (role.access[slug] === 1 || role.access['*'] === 1)" @change="change(slug, 1)">
                      </v-checkbox></div>

                      <div class="col-3">
                      <v-checkbox :readonly="!role.editable" :input-value="role.access && (role.access[slug] === 2 || role.access['*'] === 2)" @change="change(slug, 2)">
                      </v-checkbox>
                      </div>

                    </div>
                  </div>
                </v-form>
              </v-card-text>
              <v-card-actions class="text-left">

                <v-btn v-if="role.id" @click="updateTag()" :loading="loadingModal">Сохранить</v-btn>
                <v-btn v-else @click="createTag()" :loading="loadingModal">Добавить</v-btn>
                <v-btn @click="dialog = false; clearRole();" outlined>Отменить</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-data-table
              no-data-text="Нет ничего"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="roles"
              :options.sync="options"
              :footer-props="footerProps"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :loading="loading"
              loading-text="Загрузка... Подождите пожалуйста"
      >
        <template v-slot:item.actions="{ item }">
          <div class="text-right">

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="role = Object.assign({}, item); dialog = true">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>

        </v-tab-item>

        <v-tab-item>

          <v-data-table
              no-data-text="Нет ничего"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="userHeaders"
              :items="users"
              :options.sync="options"
              :footer-props="footerProps"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :loading="loading"
              loading-text="Загрузка... Подождите пожалуйста"
              v-if="users"
          >
            <template v-slot:item.role="{ item }">
              <div class="text-right">

                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">

                    <v-select class="select"
                        :items="roles"
                        :item-text="role => role.name"
                        :item-value="role => role.slug"
                        v-model="userRoles[item.id]"
                        @change="updateUser(item, userRoles[item.id])"
                    ></v-select>
                  </template>
                </v-menu>
              </div>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
      <!--</v-card>-->
    </v-col>
    <v-overlay
            :z-index="4"
            :value="overlay"
    >
    </v-overlay>
    <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            :color="snackbarColor"
            right
            top
    >
      {{ snackbarText }}
    </v-snackbar>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import ProductService from './../../api/ProductService'
    import CategoryService from './../../api/CategoryService'
    import TagService from './../../api/TagService'
    import RoleService from "@/api/RoleService";
    import Streets from "@/views/Delivery/Street/Index.vue";
    import Areas from "@/views/Delivery/Area/Index.vue";
    import UserService from "@/api/UserService";

    export default {
        name: 'TagIndex',
        components: {Areas, Streets},
        data: () => ({
            snackbar: false,
            timeout: 2000,
            snackbarText: '',
            snackbarColor: '',
            valid: false,
            submitDialog: false,
            submitItem: null,
            overlay: false,
            loadingModal: false,
            loading: true,
            tab: null,
            dialog: false,
            accessList: [],
            roles: [],
            options: {},
            users: [],
            userRoles: {},
            image: null,
            imageUa: null,
            role: {
                id: null,
                name: '',
                slug: '',
                editable: true,
                access: {},
            },
            rules: {
              required: value => !!value || 'Нужно заполнить',
              requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
            },
            footerProps: {
                itemsPerPageText: 'Тегов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
                itemsPerPageOptions: [-1]
            },
            headers: [
                {
                    text: 'ID',
                    value: 'id',
                    sortable: false
                },
                {
                    text: 'Название',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Системное название',
                    value: 'slug',
                    sortable: false
                },
                {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
            ],
            userHeaders: [
                {
                    text: 'ID',
                    value: 'id',
                    sortable: false
                },
                {
                    text: 'Email',
                    value: 'email',
                    sortable: false
                },
                {
                    text: 'Роль',
                    value: 'role',
                    sortable: false
                },
            ],
        }),
        mounted() {
          this.getDataFromApi();
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
        },
        methods: {
          updateUser(item, role) {
            UserService.updateRole({id: item.id, role});
          },
          change(slug, value) {
            let access = {...this.role.access};
            if (slug === '*') {
              if (access['*'] === value) {
                access['*'] = 0;
              } else {
                access['*'] = value;
              }

              for (const slug of this.accessList) {
                access[slug] = access['*'];
              }
            } else {
              if (access[slug] && access[slug] === value) {
                access[slug] = 0;
              } else {
                access[slug] = value;
              }

              if (access['*']) {
                access['*'] = 0;
              }
            }

            this.role.access = access;
          },
          submitDelete(item = null){
            if(item){
              this.removeTag(item)
            } else {
              // this.massDelete()
            }
          },
            validate(){
              this.$refs.tabForm.validate()
            },
            removeTag(item){
              RoleService.remove(item.id).then(response => {
                  this.loading = true
                  this.getDataFromApi()
              })
            },
            getData(){
              let formData = new FormData();
              formData.append('name', this.role.name);
              formData.append('slug', this.role.slug);
              formData.append('access', JSON.stringify(this.role.access));
              if(this.role.id){
                formData.append('id', this.role.id);
              }

              return formData
            },
            clearRole() {
              this.role = {
                name: '',
                slug: '',
                editable: true,
                access: {},
              };
            },
            createTag(){
              this.validate();
              if(!this.valid){
                return false;
              }
              let data = this.getData();
                this.loadingModal = true;
                RoleService.create(data).then(response => {
                    this.getDataFromApi();
                    this.snackbar = true;
                    this.snackbarText = 'Тег создан';
                    this.snackbarColor = 'success';
                }).catch(error => {
                  this.snackbar = true;
                  this.snackbarText = 'Ошибка при создании тега';
                  this.snackbarColor = 'error';
                }).finally(() => {
                    this.dialog = false;
                    this.loadingModal = false;
                })
            },
            updateTag(){
              this.validate();
              if(!this.valid){
                return false;
              }
              let data = this.getData();
                this.loadingModal = true;
                RoleService.update(data).then(response => {
                    this.getDataFromApi();
                    this.snackbar = true;
                  this.snackbarText = 'Роль обновлена';
                  this.snackbarColor = 'success';
                }).catch(error => {
                  this.snackbar = true;
                  this.snackbarText = 'Ошибка при обновлении тега';
                  this.snackbarColor = 'error';
                }).finally(() => {
                    this.dialog = false;
                    this.loadingModal = false;
                })
            },
            getDataFromApi() {
                this.loading = true
                this.selected = [];
                RoleService.list({})
                    .then(response => {
                        this.roles = response.data.roles.map(item => ({...item, access: JSON.parse(item.access)}));

                        this.accessList = response.data.list;
                        this.loading = false
                    })

                UserService.list({
                  roles: 1
                }).then(response => {
                  for (const user of this.users) {
                    this.userRoles[user.id] = user.role;
                  }
                  this.users = response.data;
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }

  .select {
    max-width: 200px;
    margin-top: 0;
    padding-top: 0;
  }
</style>


<style lang="scss">

</style>